var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4975 22.2401C27.8075 23.7726 27.475 24.4576 26.5875 25.8101C25.345 27.7001 23.5925 30.0601 21.4275 30.0751C19.5 30.0926 19.0025 28.8176 16.385 28.8401C13.77 28.8526 13.225 30.1001 11.295 30.0801C9.12753 30.0601 7.47003 27.9351 6.22753 26.0476C2.75253 20.7551 2.38503 14.5501 4.53253 11.2501C6.05253 8.91014 8.45503 7.53514 10.7125 7.53514C13.0125 7.53514 14.4575 8.79764 16.3575 8.79764C18.2025 8.79764 19.325 7.53264 21.985 7.53264C23.995 7.53264 26.12 8.62764 27.64 10.5176C22.67 13.2426 23.4775 20.3401 28.4975 22.2401ZM19.965 5.42014C20.9325 4.17764 21.6675 2.42514 21.4 0.640137C19.8225 0.747637 17.9775 1.75514 16.9 3.06014C15.9225 4.25014 15.1125 6.01514 15.4275 7.72264C17.15 7.77764 18.9325 6.75014 19.965 5.42014Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.a39715ae9b1337a8dca03a59f5836446.svg";
export { ForwardRef as ReactComponent };